import { SearchModes } from '@/domainLogic/index.ts';
import { type TranslationFunction } from '@/app/components/translations/Translation';
import { DESTINATION_TYPE, type SearchInfoDetailData } from '@/app/search/types.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import { type SearchParams } from '@/server/searchParams.ts';
import { replaceVar } from '../utils/misc';

const defaultTitleKey: { [key in SearchModes]: string } = {
  [SearchModes.HO]: 'vacation.oss.index.hotitle',
  [SearchModes.DP]: 'vacation.oss.index.dptitle',
  [SearchModes.TH]: 'vacation.oss.index.traintitle',
  [SearchModes.FF]: 'vacation.oss.index.flighttitle',
};

const collapsedTitleKey: { [key in SearchModes]: string } = {
  [SearchModes.HO]: 'vacation.oss.indexcollapsed.hotitle',
  [SearchModes.DP]: 'vacation.oss.indexcollapsed.dptitle',
  [SearchModes.TH]: 'vacation.oss.indexcollapsed.traintitle',
  [SearchModes.FF]: 'vacation.oss.indexcollapsed.flighttitle',
};

const collapsedAnywhereTitleKey: { [key in SearchModes]: string } = {
  [SearchModes.HO]: 'vacation.oss.indexcollapsed.hotitle_anywhere',
  [SearchModes.DP]: 'vacation.oss.indexcollapsed.dptitle_anywhere',
  [SearchModes.TH]: 'vacation.oss.indexcollapsed.traintitle_anywhere',
  [SearchModes.FF]: 'vacation.oss.indexcollapsed.flighttitle',
};

const leisureTitleKey: { [key in SearchModes]: string } = {
  [SearchModes.HO]: 'vacation.oss.indexcollapsed.hotitle_leisure',
  [SearchModes.DP]: 'vacation.oss.indexcollapsed.dptitle_leisure',
  [SearchModes.TH]: 'vacation.oss.indexcollapsed.traintitle_leisure',
  [SearchModes.FF]: 'vacation.oss.indexcollapsed.flighttitle',
};

type GetTitle = {
  searchParams: SearchParams;
  searchMode: SearchModes;
  searchInfoDetailData: SearchInfoDetailData;
  t: TranslationFunction;
};
const getTitle = ({ searchParams, searchMode, searchInfoDetailData, t }: GetTitle): string => {
  const destinationType = searchInfoDetailData?.destination?.destinationType;
  const cityName = searchInfoDetailData?.destination?.cityName;
  const countryName = searchInfoDetailData?.destination?.countryName;
  const description = searchInfoDetailData?.destination?.description;
  const descriptionLong = searchInfoDetailData?.destination?.descriptionLong;
  let title = t(defaultTitleKey[searchMode]);

  const isCity = destinationType === DESTINATION_TYPE.CITY && cityName;
  const isCountry = destinationType === DESTINATION_TYPE.COUNTRY && countryName;
  const isTag = destinationType === DESTINATION_TYPE.TAG && countryName;
  const isAnywhere = destinationType === DESTINATION_TYPE.ANYWHERE;
  const isLeisure = destinationType === DESTINATION_TYPE.LEISURE;

  const origin = searchParams[URLParameters.ORIGIN] || '';
  if (isCity || isTag) {
    title = t(collapsedTitleKey[searchMode]);
    title = replaceVar(title.replace(/__(.*?)__/g, '{$1}'), { origin, destination: description });
  } else if (isCountry) {
    title = t(collapsedTitleKey[searchMode]);
    title = replaceVar(title.replace(/__(.*?)__/g, '{$1}'), { origin, destination: description });
  } else if (isAnywhere) {
    title = t(collapsedAnywhereTitleKey[searchMode]);
    title = replaceVar(title.replace(/__(.*?)__/g, '{$1}'), { origin, anywhere: description?.toLowerCase() });
  } else if (isLeisure) {
    title = t(leisureTitleKey[searchMode]);
    title = replaceVar(title.replace(/__(.*?)__/g, '{$1}'), { origin, holidayType: descriptionLong });
  }

  return title;
};

export default getTitle;
